// Ostrva traže svoje elemente po data-js. Kada element nedostaje ili nije očekivanog tipa, oznaka i skripta su se
// razišle, pa skripta puca odmah, umesto da tiho ne radi.
type ElementType<T extends Element> = abstract new () => T;

export function find<T extends Element>(root: ParentNode, name: string, type: ElementType<T>): T {
  const element = root.querySelector(`[data-js="${name}"]`);
  if (!(element instanceof type)) throw new Error(`Nedostaje [data-js="${name}"] (${type.name}).`);
  return element;
}

export function findAll<T extends Element>(root: ParentNode, name: string, type: ElementType<T>): T[] {
  return Array.from(root.querySelectorAll(`[data-js="${name}"]`), element => {
    if (!(element instanceof type)) throw new Error(`[data-js="${name}"] nije ${type.name}.`);
    return element;
  });
}

// Traka koja se prevlači pomeri se tako da je izabrani element na sredini; stranica se pri tom ne pomera.
export function centerInStrip(strip: HTMLElement, chosen: HTMLElement): void {
  const offset = chosen.getBoundingClientRect().left - strip.getBoundingClientRect().left;
  strip.scrollLeft += offset - (strip.clientWidth - chosen.offsetWidth) / 2;
}

export function data(element: HTMLElement, name: string): string {
  const value = element.dataset[name];
  if (value === undefined) throw new Error(`Nedostaje data-${name} na [data-js="${element.dataset['js'] ?? ''}"].`);
  return value;
}
